import React from "react";
import { motion } from "framer-motion";
import { FiArrowUpRight, FiCopy, FiDownload, FiMail } from "react-icons/fi";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import Magnetic from "../ui/Magnetic";
import useCopyEmail from "../../hooks/useCopyEmail";
import useLocalTime from "../../hooks/useLocalTime";
import { profile } from "../../data/resume";
import { fadeUp, staggerChildren, trackSpotlight, viewportOnce } from "../../utils/motionPresets";
import CV from "../../assets/Yaseen-Al-Midani.pdf";
import "./contact.css";

const channels = [
  { label: "Email", value: profile.email, href: `mailto:${profile.email}`, Icon: FiMail },
  { label: "LinkedIn", value: "Yaseen Al-Midani", href: profile.linkedin, Icon: FaLinkedinIn, external: true },
  { label: "GitHub", value: "@yaseenmi", href: profile.github, Icon: FaGithub, external: true },
  { label: "Résumé", value: "Download PDF", href: CV, Icon: FiDownload, download: true }
];

const Contact = () => {
  const copyEmail = useCopyEmail();
  const time = useLocalTime(profile.timeZone);

  return (
    <section className="section contact" id="contact">
      <div className="contact__glow" aria-hidden="true" />
      <motion.div
        className="container"
        variants={staggerChildren}
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
      >
        <motion.span className="eyebrow" variants={fadeUp}>
          <span className="eyebrow__index">06</span>
          Contact
        </motion.span>

        <motion.h2 className="contact__title" variants={fadeUp}>
          Have an idea?
          <br />
          <span className="serif">Let's build it.</span>
        </motion.h2>

        <motion.div className="contact__actions" variants={fadeUp}>
          <Magnetic strength={0.2}>
            <a href={`mailto:${profile.email}`} className="btn btn--primary contact__primary">
              Start a conversation <FiArrowUpRight />
            </a>
          </Magnetic>
          <button type="button" className="contact__copy" onClick={copyEmail}>
            <span className="mono">{profile.email}</span>
            <span className="contact__copy-icon">
              <FiCopy />
            </span>
            <span className="sr-only">Copy email address</span>
          </button>
        </motion.div>

        <motion.ul className="contact__grid" variants={staggerChildren}>
          {channels.map(({ label, value, href, Icon, external, download }) => (
            <motion.li key={label} variants={fadeUp}>
              <a
                href={href}
                className="card contact__card"
                onPointerMove={trackSpotlight}
                {...(external ? { target: "_blank", rel: "noreferrer" } : {})}
                {...(download ? { download: "Yaseen-Al-Midani-CV.pdf" } : {})}
              >
                <span className="contact__card-icon">
                  <Icon />
                </span>
                <span className="contact__card-text">
                  <small>{label}</small>
                  <span>{value}</span>
                </span>
                <FiArrowUpRight className="contact__card-arrow" aria-hidden="true" />
              </a>
            </motion.li>
          ))}
        </motion.ul>

        <motion.p className="contact__note" variants={fadeUp}>
          <span className="contact__note-dot" />
          {profile.city} · <span className="mono">{time} GST</span> — I read every message and reply
          as soon as possible.
        </motion.p>
      </motion.div>
    </section>
  );
};

export default Contact;
